export interface RouteExistenceObservation {
  workspaceId: string | undefined;
  selectedDate: string | undefined;
  hasRoutes: boolean;
}

export interface RouteExistenceTracker {
  // Returns true when `hasRoutes` flipped (0 ↔ 1+) for the *same* workspace+date
  // context as the previous observation — i.e. a route was added or removed
  // while the user stayed put. Returns false for the first observation and for
  // any change of workspace or date (those are navigations, not mid-session
  // flips). Callers should only observe *settled* states (not while route data
  // is loading) so a cross-context load is never read as a flip.
  observe(observation: RouteExistenceObservation): boolean;
}

export const createRouteExistenceTracker = (): RouteExistenceTracker => {
  let lastKey: string | undefined;
  let lastHasRoutes = false;
  let hasObserved = false;

  return {
    observe({ workspaceId, selectedDate, hasRoutes }) {
      const key = `${workspaceId}:${selectedDate}`;
      const changed = hasObserved && key === lastKey && hasRoutes !== lastHasRoutes;
      lastKey = key;
      lastHasRoutes = hasRoutes;
      hasObserved = true;
      return changed;
    },
  };
};
